import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import {
  CellsConfig,
  ContextItem,
  RequirementTableCallback
} from "../../../../types";
import { getPayoutMethodRequirementName } from "../helpers/getPayoutMethodRequirementName";
import { getPayoutMethodRequirementPayerStatusCell } from "../helpers/getPayoutMethodRequirementPayerStatusCell";

export const usePayerPayoutMethodConfig = (
  _: RequirementTableCallback
): CellsConfig<PayeeRequirement, ContextItem, undefined> => {
  return {
    isActionRequired: () => false,

    requirementName: getPayoutMethodRequirementName,

    toolbarActions: () => [],

    nameCell: requirement => ({
      text: getPayoutMethodRequirementName(requirement)
    }),

    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.type!
      }),

    statusCell: getPayoutMethodRequirementPayerStatusCell
  };
};
